const ROUTE_ENUM = {
  HOME: "/home",
  DASHBOARD: "/dashboard",
  LOG_IN: "/login",
  LOG_OUT: "/logout",
  AUTH_CALLBAK: "/authCallback",
  AUTH_CALLBAK_MOBILE_APP: "/authCallbackMobileApp",
  FORMS: "/forms",
  FORM_TEMPLATES_DASHBOARD: "/form-templates-dashboard",
  FORM_TEMPLATES_RESPONSES: "/form-templates-responses",
  FORM_TEMPLATE: "/form-template",
  FORM_BUILDER: "/form-builder",
  FORM_SUBMISSION: "/form-submission",
  FORM_CC_RECEIPT: "/cc-receipt",
  HISTORY: "/history",
  FORM_CC_RECEIPT_FORMS: "/cc-receipt-forms",
  ANONYMOUS: "/:catchAll(.*)*",
  ADMIN: "/admin",
  TAGS: "/tags",
  FLRA_FORMS_DASHBOARD: "/flra-forms-dashboard",
  FLRA_FORM: "/flra-form",
  DEFECTS_FORM: "/defects-form",
  INSPECTION_FORM: "/inspection-form",
  SR_MANAGEMENT_FORM: "/senior-management-form",
  DAILY_WORK_EXAMINATION_FORM: "/daily-work-examination-form",
  SETTINGS: "/settings",
  SHIPPING_REQUEST_FORM: "/shipping-request-form",
  SHIPPING_REQUESTS_DASHBOARD: "/shipping-requests-dashboard",
  TRIGGER_DASHBOARD: "/trigger-management-dashboard",
  LWI_DASHBOARD: "/lwi-dashboard",
  DYNAMIC_REPORT_FORM: "/dynamic-report-form",
  PATROL_REPORT_DASHBOARD: "/patrol-report-dashboard",
  BLADES_SHOP_DASHBOARD: "/blades-shop-dashboard",
  MASTER_UNIT_DASHBOARD: "/master-unit-dashboard",
  PATROL_WEEKLY_REPORT_DASHBOARD: "/patrol-weekly-report-dashboard",
  MASTER_INVENTORY_DASHBOARD: "/master-inventory-dashboard",
  INVENTORY_RECONCILIATION_DASHBOARD: "/inventory-reconciliation-dashboard",
  PERMISSION_DENIED: "/permission-denied",
  STATIC_FLHA_FORM: "/static-flha-form"
};

const TABLES_NAME_ENUM = {
  DYNAMIC_FROMS_TABLE: "dynamic_forms",
  TAGS_TABLE: "tags",
  ASSETS_TABLE: "assets",
  FLRA_ITEMS_LIST_TABLE: "flra_items_list",
  FLRA_JOB_CATS_TABLE: "flra_job_cats",
  FLRA_BRANCHES_TABLE: "flra_branches",
  FLRA_DYNAMIC_FORMS_TABLE: "flra_dynamic_forms",
  EMPLOYEE_TABLE: "employee",
  FLRA_FORM_TABLE: "flra_forms",
  FLRA_FORM_SUMMARY_ITEMS_TABLE: "flra_forms_summary_items",
  SIGNATURES_TABLE: "signatures",
  ACTIONS_TABLE: "actions",
  FLRA_STATUS_TABLE: "flra_status",
  JOB_PLAN_INFO_TABLE: "job_plan_info",
  PROFILE_TABLE: "profiles",
  EMAIL_QUEUE_TABLE: "email_queue",
  PDF_LAYOUTS: "pdf_layouts",
  ATTACHMENTS_TABLE: "attachments",
  FORM_TEMPLATES_TABLE: "form_templates",
  FORM_TEMPLATES_RESPONSES_TABLE: "form_templates_responses",
  FORM_PAGES_TABLE: "form_pages",
  FORM_FIELDS_TABLE: "form_fields",
  SR_MANAGEMENT_LOCATIONS_LIST_TABLE: "sr_mngmt_locations",
  SR_MANAGEMENT_FORMS_TABLE: "sr_management_forms_submissions",
  DAILY_WORK_EXAMINATION_FORM_TABLE:
    "daily_work_examinations_forms_submissions",
  PRE_DEFINED_LIST_TABLE: "pre_defined_lists",
  PDF_LAYOUTS_TABLE: "pdf_layouts",
  PDF_ADDON_LAYOUTS_TABLE: "pdf_addon_layouts",
  SHIPPING_REQ_LIST_TABLE: "shipping_requests",
  TRIGGER_SETTINGS_TABLE: "trigger_settings",
  APP_SETTINGS_TABLE: "app_settings",
  SEQUENCE_ROUTING_TABLE: "sequence_routing",
  RXDB_SCHEMAS_TABLE: "rxdb_schemas",
  EXCEPTIONS_TABLE: "exceptions",
  // for patrolling report
  CMA_519_USERS_LAT_LONG_TABLE: "cma_519_users_lat_long",
  FLEET_COMPLETE_GPS_TABLE: "fleet_complete_gps",
  PATROL_STATUS_REPORT_QC_DATA_TABLE: "weekly_patrol_qa_qc",
  PATROL_STATUS_REPORT_QC_HISTORY_TABLE: "weekly_patrol_qa_qc_history",
  // for blades
  BLADES_EVENTS_TABLE: "blades_events",
  BLADES_EVENT_DETAILS_TABLE: "blades_event_details",
  BLADES_INVENTORY_TABLE: "blades_inventory",
  BLADES_PURCHASES_TABLE: "blades_purchases",
  BLADES_RECEIPTS_TABLE: "blades_receipts",
  BLADES_TRANSACTION_DETAILS_TABLE: "blades_transaction_details",
  BLADES_ADJUSTMENT_DETAILS_TABLE: "blades_adjustment_details",
  BLADES_TRANSFERS_TABLE: "blades_transfers",
  BLADES_TYPES_TABLE: "blades_types",
  BLADES_SHOPS_TABLE: "blades_shops",
  BLADES_UNITS_TABLE: "blades_units",
  BLADES_INVENTORY_VIEW_TABLE: "blades_inventory_view",
  MASTER_SHOPS_TABLE: "master_shops",
  MASTER_REGIONS_TABLE: "master_regions",
  MASTER_COMPANIES_TABLE: "master_companies",
  USER_ROLES_TABLE: "user_roles",
  USER_ACCESS_GROUPS_TABLE: "user_access_groups",
  FLHA_ITEMS_LIST_TABLE: "flha_items_list",
  PATROL_STATUS_TABLE: "patrol_status_v3",
  EMAIL_TEMPLATES_TABLE: "email_templates"
};

const DATABASE_FUNCTION_ENUM = {
  GET_COLUMN_NAMES: "get_column_names",
  CHECK_AND_CREATE_TABLE: "check_and_create_table",
  SETUP_RLS_FOR_AUTHENTICATED_USERS: "setup_rls_for_authenticated_users",
  GET_NEXT_SEQUENCE_VALUE: "get_next_sequence_val",
  GET_STATUS_COUNTS: "get_status_counts",
  GET_HIGHWAY_PINS: "get_defects_form_responses",
  GET_INSPECTION_HIGHWAY_PINS: "get_inspections_form_responses",
  GET_INSPECTION_COUNTS: "get_inspection_counts",
  GET_PATROL_STATUS_REPORT: "export_weekly_patrol_report_v2",
  GET_WEEKLY_PATROL_REPORT_GPS_DATA: "export_device_gps_data",
  GET_WEEKLY_DEFECTS_REPORT: "get_defects_report",
  GET_BLADES_UNITS_WITH_CHANGE_INFO: "get_unit_info",
  GET_BLADE_EVENT_DETAILS: "get_blade_event_details",
  BLADES_INVENTORY_RECONCILIATION_DISCREPANCIES: "blades_inventory_reconciliation_discrepancies"
};

const RXDB_COLLECTIONS_ENUM = {
  RXDB_SCHEMAS: TABLES_NAME_ENUM.RXDB_SCHEMAS_TABLE
};

const API_RESPONSE_STATUS_ENUM = {
  FETCH_SUCCESS: 200,
  INSERT_SUCCESS: 201,
  UPDATE_SUCCESS: 204,
  DELETE_SUCCESS: 204
};

const DATASTORE_BUCKET_ENUM = {
  ASSETS: "/assets",
  ATTACHMENTS: "/attachments/test",
  FLRA_ATTACHMENTS: "/attachments/flra"
};

const DEVICE_TYPE = {
  MOBILE: "MOBILE",
  TABLET: "TABLET",
  DESKTOP: "DESKTOP"
};

const COMPANY_OPTIONS = {
  LCR: "LCR",
  CAP: "CAP",
  ENT: "ENT",
  CSI: "CSI",
  WTI: "WTI",
  FGR: "FGR"
};

const FLRA_STATUS = {
  CANCELLED: "CANCELLED",
  NEW: "NEW",
  OPEN: "OPEN",
  PENDING_REVIEW: "PENDING REVIEW",
  REVIEWED: "REVIEWED",
  DONE: "DONE"
};

const DEFECTS_STATUS = {
  NEW: "NEW",
  SUBMITTED: "SUBMITTED",
  PENDING: "PENDING",
  ON_HOLD: "ON HOLD",
  IN_PROGRESS: "IN PROGRESS",
  FOREMAN_REVIEW: "IN REVIEW",
  DONE: "DONE",
  COMPLETED: "COMPLETED",
  QC_FAIL: "QC FAIL",
  QC_CHECK: "QC CHECK",
  CANCELLED: "CANCELLED",
  IN_REVIEW: "IN REVIEW"
};

const QC_STATUS_OPTIONS = {
  PATROLLED: "Patrolled",
  SCHEDULED: "Scheduled",
  QC_PASS: "Patrolled*",
  QC_CHECK: "QC Check",
  QC_FAIL: "QC Fail",
  NON_PATROL: "Non Patrol"
};

/**
 * Weekly Patrol Report status cell CSS classes (single source of truth for table + Legend).
 */
const PATROL_REPORT_STATUS_CLASSES = {
  empty: "",
  emptyGray: "bg-gray-100 text-gray-600",
  patrolledScheduled:
    "bg-green-100 text-green-800 font-bold cursor-pointer hover:bg-green-200",
  patrolledNotScheduled:
    "bg-green-100 text-green-800 font-bold cursor-pointer hover:bg-green-200 border-2 border-dotted border-green-800",
  qcCheckScheduled:
    "bg-orange-100 text-orange-800 cursor-pointer hover:bg-orange-200",
  qcCheckNotScheduled:
    "bg-orange-100 text-orange-800 cursor-pointer hover:bg-orange-200 border-2 border-dotted border-orange-700",
  qcFailScheduled: "bg-red-100 text-red-800 cursor-pointer hover:bg-red-200",
  qcFailNotScheduled:
    "bg-red-100 text-red-800 cursor-pointer hover:bg-red-200 border-2 border-dotted border-red-700",
  nonPatrol: "bg-gray-100 text-gray-800 cursor-pointer hover:bg-gray-200",
  scheduled:
    "bg-blue-50 text-blue-800 cursor-pointer hover:bg-blue-200",
  default: "bg-gray-100 text-gray-600"
};

// Defect status groups configuration
const DEFECT_STATUS_GROUPS = {
  IN_REVIEW: {
    key: "IN_REVIEW",
    label: "IN REVIEW",
    prefix: "+",
    statuses: [
      DEFECTS_STATUS.SUBMITTED,
      DEFECTS_STATUS.NEW,
      DEFECTS_STATUS.QC_FAIL,
      DEFECTS_STATUS.FOREMAN_REVIEW
    ],
    cssClasses: "text-red-700 bg-red-100",
    progressColor: "danger",
    individualStatuses: {
      [DEFECTS_STATUS.SUBMITTED]: {
        iconClass: "pi pi-clock"
      },
      [DEFECTS_STATUS.NEW]: {
        iconClass: "pi pi-circle"
      },
      [DEFECTS_STATUS.QC_FAIL]: {
        iconClass: "pi pi-times"
      },
      [DEFECTS_STATUS.FOREMAN_REVIEW]: {
        iconClass: "pi pi-times"
      }
    }
  },
  OPEN: {
    key: "OPEN",
    label: "OPEN",
    statuses: [DEFECTS_STATUS.IN_PROGRESS],
    cssClasses: "text-orange-700 bg-orange-100",
    progressColor: "primary",
    individualStatuses: {
      [DEFECTS_STATUS.IN_PROGRESS]: {
        iconClass: "pi pi-clock"
      }
    }
  },
  PENDING: {
    key: "PENDING",
    label: "PENDING",
    statuses: [DEFECTS_STATUS.ON_HOLD, DEFECTS_STATUS.PENDING],
    cssClasses: "text-sky-700 bg-sky-100",
    progressColor: "info",
    individualStatuses: {
      [DEFECTS_STATUS.ON_HOLD]: {
        iconClass: "pi pi-clock"
      },
      [DEFECTS_STATUS.PENDING]: {
        iconClass: "pi pi-clock"
      }
    }
  },
  QC_CHECK: {
    key: "QC_CHECK",
    label: "QC CHECK",
    statuses: [DEFECTS_STATUS.QC_CHECK],
    cssClasses: "text-gray-800 bg-gray-50",
    progressColor: "secondary",
    individualStatuses: {
      [DEFECTS_STATUS.QC_CHECK]: {
        iconClass: "pi pi-clock"
      }
    }
  },
  CLOSED: {
    key: "CLOSED",
    label: "CLOSED",
    prefix: "-",
    statuses: [DEFECTS_STATUS.COMPLETED, DEFECTS_STATUS.CANCELLED],
    cssClasses: "text-green-700 bg-green-100",
    progressColor: "success",
    individualStatuses: {
      [DEFECTS_STATUS.COMPLETED]: {
        iconClass: "pi pi-check-circle"
      },
      [DEFECTS_STATUS.CANCELLED]: {
        iconClass: "pi pi-times"
      }
    }
  }
};
const FLRA_STATUS_IDS = {
  NEW_ID: 1,
  OPEN_ID: 2,
  PENDING_REVIEW_ID: 3,
  REVIEWED_ID: 4,
  DONE_ID: 5,
  CANCELLED_ID: 6
};

const FLRA_USER_ROLES = {
  SUBMITTER: 1,
  ADMIN: 2,
  SUPER_ADMIN: 3,
  SUPERVISOR: 4,
  SHIPPING_ADMIN: 5,
  BLADES_APPROVAL_ADMIN: 6
};

const FLRA_FORMS_CATEGORY = {
  MY_FLRA: "My FLRA",
  FLRA_REVIEW: "FLRA's Review"
};

const HSE_EMAILS = {
  CRANE: "hse@laprairiecrane.com",
  ENT: "hse@entrec.laprairiegroup.com",
  CAP: "hse@capstan.laprairiegroup.com"
};

const FLRA_COMPANIES = {
  CRANE: "lpcrane",
  ENT: "entrec",
  CAP: "capstan"
};

const FLRA_COMPANIES_OPTIONS = {
  CRANE: "LPCrane",
  ENT: "Entrec",
  CAP: "Capstan"
};

const FLRA_FORM_FIELD = {
  COMPANY: "company",
  WORKING_BRANCH: "workingBranch",
  JSA_JOB_CAT: "jsaJobCat",
  CREATED_BY_NAME: "created_by_name",
  STATUS_NAME: "status_name",
  CREATED_AT: "created_at",
  DATE: "date",
  FLRA_NUM: "flraNum"
};

const NO_REPLY_EMAILS_ID = {
  NO_REPLY_APP: "d89267e5-07c1-49ff-9c67-00487c604b3e" // noreply.app@laprairiegroup.com
};

/** Pre-defined list row IDs (e.g. for workhub forms mapping) */
const PRE_DEFINED_LIST_IDS = {
  WORKHUB_FORMS_MAPPING: "d4f5e6a7-1042-4111-a111-000000104201"
};

/** Workhub form name slugs (used in pre_defined_lists workhub forms mapping) */
const WORKHUB_FORM_NAMES = {
  SR_MANAGEMENT_FORM: "sr_management_form"
};

const PROJECT_ENVIRONMENT = {
  DEV: "development",
  STAGING: "staging",
  PRODUCTION: "production",
  CURRENT: import.meta.env.VITE_ENVIRONMENT
};

const NAVIGATION_BTN_ACTIONS = {
  ON_NEXT: "ON_NEXT",
  ON_BACK: "ON_BACK",
  ON_SAVE: "ON_SAVE",
  ON_UPDATE: "ON_UPDATE",
  ON_SUBMIT: "ON_SUBMIT",
  ON_DYNAMIC_REPORT: "ON_DYNAMIC_REPORT",
  ON_PDF_PREVIEW: "ON_PDF_PREVIEW",
  ON_FOE_PDF_PREVIEW: "ON_FOE_PDF_PREVIEW",
  ON_COMPLETE: "ON_COMPLETE",
  ON_CANCEL: "ON_CANCEL",
  ON_IMG_INFO_TRIGGER_BTN: "ON_IMG_INFO_TRIGGER_BTN",
  ON_CAMERA_SELECT_TRIGGER_BTN: "ON_CAMERA_SELECT_TRIGGER_BTN",
  ON_FILE_SELECT_TRIGGER_BTN: "ON_FILE_SELECT_TRIGGER_BTN",
  ON_CARWALD_INVOICE_CREDIT: "ON_CARWALD_INVOICE_CREDIT",
  ON_CARWALD_INVOICE_REBILL: "ON_CARWALD_INVOICE_REBILL",
  ON_CARWALD_INVOICE_PDF_PREVIEW: "ON_CARWALD_INVOICE_PDF_PREVIEW",
  ON_ROUTE_TO_PAGE: "ON_ROUTE_TO_PAGE",
  OPEN_POTHOLE_FORM: "OPEN_POTHOLE_FORM",
  REVERSE_START_END: "REVERSE_START_END",
  GET_AND_SET_LATLONG: "GET_AND_SET_LATLONG",
  OPEN_GOOGLE_MAPS_DIALOG: "OPEN_GOOGLE_MAPS_DIALOG",
  ON_NEW_FORM: "ON_NEW_FORM",
  ON_SEND_EMAIL: "ON_SEND_EMAIL",
  SHOW_INFORMATION_DIALOG: "SHOW_INFORMATION_DIALOG",
  OPEN_ADD_MORE_MENU: "OPEN_ADD_MORE_MENU"
};

const FORM_TEMPLATE_IDS = {
  BLADES_PURCHASE_FORM: "f719e665-ffdf-4967-bd1b-e5054f2c7725",
  BLADES_ACCESSORIES_FORM: "8eadeec5-1b53-4391-a788-582e83de7d6d",
  BLADES_SHOP_DASHBOARD: "96ad08c6-5862-4701-a817-1cabf2c53298",
  MASTER_UNIT_DASHBOARD: "c0e460ea-3bb1-4cc2-87ea-985990257e26",
  BLADES_TRANSFER_FORM: "cc2b5e11-5340-4853-a694-c3287465511d",
  UNIT_TRANSFER_FORM: "62e38ade-14af-4dcc-8961-f5c9b33d8ed1",
  MASTER_INVENTORY_DASHBOARD: "bacefccd-68cb-40ca-9569-d32df87bb119",
  INVENTORY_RECONCILIATION_DASHBOARD: "5735dac0-5456-4a56-9829-1c18c0fbf4e2",
  INVENTORY_COUNT_FORM: "d258a600-9310-46ca-a494-4165bdac09a3",
  DEFECTS_FORM: "e8b5a620-f84d-11ee-a506-0242ac120002",
  INSPECTION_FORM: "e740f538-ba6c-4753-99c7-cc0859644a71",
  QA_QC_FORM: "78d84465-2cf4-498b-905d-d930f8007a57",
  JOBS_FORM: "0a446749-e6f8-4af0-b1a7-c38c40ce4675",
  DOC_CENTER_FORM: "1b26225a-a5d2-4408-9451-380924a04683",
  BEHAVIOUR_BASED_FORM: "23f172cf-22ed-4a46-8045-59635604c4ba",
  INVOICE_FORM: "62a714d5-bf44-4ba8-bf45-0325642519d7",
  MANBASKET_INSPECTION_FORM: "b693f0aa-8294-492c-8468-1acd618760f1",
  FLHA_FORM: "c36ad69a-6c09-4ddd-ae49-710e9c008dcd",
  FIELD_ORDER_FORM: "d48104d0-cae7-4a24-9115-1781a3ad9db3",
  HEIGHTS_RESCUE_FORM: "fb77a107-8e5b-4bd7-8116-830a8c509b4b",
  FLRA_FORM: "a577e57b-1e5c-495d-85ac-de081b425360",
  LWI_DASHBOARD: "3e8f6e7e-dff0-4b1f-a0ac-fada79ebad6b",
  PATROL_WEEKLY_REPORT_DASHBOARD: "9ba7e3a1-2734-4c1d-9586-e1f2f1693ffe",
  SR_MANAGEMENT_FORM: "d0bb4158-05fa-4104-a881-48b35ef2c5c7",
  DAILY_WORK_EXAMINATION_FORM: "647bf9c4-b6d3-4e41-a52d-89df66c1126b",
  SHIPPING_REQUESTS_DASHBOARD: "4c8dbe4d-960b-4dc7-b9dc-4df194e22be4",
  PATROL_REPORT_DASHBOARD: "32d78eaa-ae71-4123-a35a-0ceba4cb5073",
  FORM_TEMPLATES_DASHBOARD: "f4067fe2-e0c5-40dc-869a-5876aa67b1ba",
  FORM_TEMPLATES_RESPONSES: "8e500b79-e770-4182-a468-19b1b1ea3358",
  FORMS_DASHBOARD: "7044a75d-38a7-4490-82b2-816aba192595",
  TAGS_DASHBOARD: "d421ea85-55a0-4a17-abcd-f94026c0d305",
  TRIGGER_MANAGEMENT_DASHBOARD: "da609d0d-1c7c-409a-94fe-c68387eb3256",
  DYNAMIC_REPORT_FORM: "108e062c-06ab-454f-b575-56adc45b31db",
  USER_PROFILE_DASHBOARD: "14acd442-5a13-4f9e-b098-1e1673feafcc",
  STATIC_FLHA_FORM: "2aacc72c-c018-46ff-8009-05162cf283a8"
};

const SUPER_ADMIN_ID = {
  SUPER_ADMIN_ID: "8f19e6a5-a327-4ba1-bc2c-08c355c74df2"
};

const FIELD_TYPES = {
  INPUT_TXT: "INPUT_TXT",
  TXT_AREA: "TXT_AREA",
  TITLE_2: "TITLE_2",
  TITLE_1: "TITLE_1",
  TITLE_3: "TITLE_3",
  TRIGGER_BTN: "TRIGGER_BTN",
  INPUT_NUMBER: "INPUT_NUMBER",
  INPUT_DATE_TIME_PICKER: "INPUT_DATE_TIME_PICKER",
  DROPDOWN: "DROPDOWN",
  TOGGLE: "TOGGLE",
  CHECKBOX: "CHECKBOX",
  RADIO_GROUP: "RADIO_GROUP",
  TXT: "TXT",
  CALCULATED: "CALCULATED",
  AUTO_INCREMENT: "AUTO_INCREMENT",
  SINGLE_SIGNATURE: "SINGLE_SIGNATURE",
  ATTENDEE_SIGNATURES: "ATTENDEE_SIGNATURES",
  HTML: "HTML",
  STATUS_BAR: "STATUS_BAR",
  HIDDEN_FIELD: "HIDDEN_FIELD",
  REF_FIELD: "REF_FIELD",
  SELECT: "SELECT",
  SIMPLE_NAME_INPUT: "SIMPLE_NAME_INPUT",
  SPACER: "SPACER"
};

// These field types are not required to be validated as they do not have inputs
// If a new field type is added that should not be validated, it should be added to this array
const FIELD_TYPES_DONT_VALIDATE = [
  FIELD_TYPES.TITLE_1,
  FIELD_TYPES.TITLE_2,
  FIELD_TYPES.TITLE_3,
  FIELD_TYPES.HTML
];

const PAGE_TEMPLATE_TYPE = {
  QC_SUMMARY_LIST: "QC_SUMMARY_LIST",
  PROCEDURES_LIST: "PROCEDURES_LIST",
  ATTENDEES: "ATTENDEES",
  CARD_LIST: "CARD_LIST"
};

const PROGRESS_STATUS = {
  IN_PROGRESS: "In Progress",
  COMPLETE: "Completed",
  NOT_STARTED: "Not Started",
  UNKNOWN: "Unknown"
};

const IMAGE_PREVIEW_TYPE = {
  IN_PAGE: "IN_PAGE",
  LIST_DIALOGUE: "LIST_DIALOGUE",
  IN_BUTTON: "IN_BUTTON"
};
const DEBOUNCE_TIME = {
  MS_0: 0,
  MS_300: 300,
  MS_500: 500,
  MS_1000: 1000,
  MS_2000: 2000
};

const FORM_TYPE = {
  DAILY_WORK: "Daily Work Examinations",
  SR_MANAGEMENT: "Sr Management"
};

const COMPARISON_TYPE = {
  CS: "contains",
  EQ: "eq",
  IS: "is",
  OR: "or",
  NOT_EQ: "not_eq",
  AND: "and",
  JSON_CS: "json_contains",
  JS_EQ: "==",
  JS_NOT_EQ: "!=",
  JS_AND: "&&",
  JS_OR: "||",
  BETWEEN: "between",
  GT: "gt",
  LT: "lt",
  NOT: "not",
  JS_NOT: "!",
  IN: "in",
  IS_LIKE: "is_like"
};

// we should not do this and should use the form template id from the database table for this type of static refrence
// but for now we are using this
// This is a useful work around for static forms that do not come from a template
const STATIC_FORM_TEMPLATE_ID = {
  INVOICE_FORMS: "62a714d5-bf44-4ba8-bf45-0325642519d7",
  FLRA_FORMS: "a577e57b-1e5c-495d-85ac-de081b425360",
  DAILY_WORK_EXAMINATION_FORMS: "647bf9c4-b6d3-4e41-a52d-89df66c1126b",
  SR_MANAGEMENT_FORMS: "d0bb4158-05fa-4104-a881-48b35ef2c5c7"
};
const FILE_EXTENSION_TYPE = {
  PDF: "pdf"
};

const IMAGE_EXTENSION_TYPE = {
  JPG: "jpg",
  JPEG: "jpeg",
  PNG: "png",
  GIF: "gif",
  WEBP: "webp",
  SVG: "svg"
};

const EMAIL_ACTION_TYPES = {
  SUBMISSION: "SUBMISSION",
  APPROVAL: "APPROVAL",
  FLRA_NOTIFICATION: "FLRA_NOTIFICATION",
  PAR_PENDING_PO_NOTIFICATION: "PAR_PENDING_PO_NOTIFICATION",
  PAR_PO_ISSUED: "PAR_PO_ISSUED",
  PAR_SUBMISSION: "PAR_SUBMISSION",
  PAR_REQUIRE_APPROVAL: "PAR_REQUIRE_APPROVAL"
};

const EMAIL_RECIPIENT_TYPES = {
  ME: "ME",
  SUPERVISOR: "SUPERVISOR",
  REQUESTOR: "REQUESTOR",
  SUBMITTER: "SUBMITTER",
  NO_REPLY_APP: "NO_REPLY_APP"
};

const FORM_TYPES = {
  FLRA: "d64c9d30-4b38-4a9b-a27d-0fc85c7f5ef2",
  SHIPPING: "f2ac8024-10b7-4d92-a395-2c1e8e9a59e9",
  INVOICE: "62a714d5-bf44-4ba8-bf45-0325642519d7"
};

const APP_SETTINGS = {
  CURRENT_WEB_VERSION: "CURRENT_WEB_VERSION",
  CURRENT_ANDROID_VERSION: "CURRENT_ANDROID_VERSION",
  CURRENT_IOS_VERSION: "CURRENT_IOS_VERSION",
  FORCE_UPDATE_VERSION: "FORCE_UPDATE_VERSION",
  SYNC_TIMEOUT: "SYNC_TIMEOUT",
  SWIPE_NAVIGATION_THRESHOLD: "SWIPE_NAVIGATION_THRESHOLD",
  MIN_TOKEN_AGE: "MIN_TOKEN_AGE"
};

const ERROR_TYPE = {
  OFFLINE: "offline",
  GENERIC: "generic"
};

const BEFORE_AFTER_ACTION_TYPES = {
  UPDATE_RESPONSE: "UPDATE_RESPONSE",
  NEGATE_RESPONSE: "NEGATE_RESPONSE",
  ADD_PREFIX_TO_RESPONSE: "ADD_PREFIX_TO_RESPONSE",
  ADD_SUFFIX_TO_RESPONSE: "ADD_SUFFIX_TO_RESPONSE",
  GENERATE_AUTO_INCREMENT: "GENERATE_AUTO_INCREMENT",
  GET_AUTO_INCREMENT: "GET_AUTO_INCREMENT",
  GET_AUTO_INCREMENT_VALUE: "GET_AUTO_INCREMENT_VALUE",
  ROUTE_TO_PAGE: "ROUTE_TO_PAGE",
  TOAST_NOTIFICATION: "TOAST_NOTIFICATION",
  VERSION_UPDATE_EMAIL: "VERSION_UPDATE_EMAIL",
  SET_CURRENT_FORM_RESPONSE_LINK: "SET_CURRENT_FORM_RESPONSE_LINK",
  SET_SUBMITTED_FORM_LINK_TO_LOCAL_TEMP_STORAGE_OBJ:
    "SET_SUBMITTED_FORM_LINK_TO_LOCAL_TEMP_STORAGE_OBJ",
  GET_SUBMITTED_FORM_LINK_TO_LOCAL_TEMP_STORAGE_OBJ:
    "GET_SUBMITTED_FORM_LINK_TO_LOCAL_TEMP_STORAGE_OBJ",
  SEND_EMAIL: "SEND_EMAIL",
  SEND_EMAIL_AUTO: "SEND_EMAIL_AUTO",
  TRIGGER_CLICK_BUTTON: "TRIGGER_CLICK_BUTTON",
  OPEN_DIALOG: "OPEN_DIALOG",
  SHOW_DIALOG: "SHOW_DIALOG",
  SHOW_ERROR_DIALOG: "SHOW_ERROR_DIALOG",
  SHOW_CONFIRMATION_DIALOG: "SHOW_CONFIRMATION_DIALOG",
  RUN_ACTION_FLOW: "RUN_ACTION_FLOW",
  FETCH_AND_UPDATE_RESPONSE: "FETCH_AND_UPDATE_RESPONSE",
  GET_AND_SET_LATLONG: "GET_AND_SET_LATLONG",
  VALIDATE_FORM: "VALIDATE_FORM",
  SET_CURRENT_TIMESTAMP: "SET_CURRENT_TIMESTAMP",
  FORMAT_TIMESTAMP: "FORMAT_TIMESTAMP",
  OPEN_ADD_MORE_MENU: "OPEN_ADD_MORE_MENU"
};

const DATE_FILED = {
  TODAY: "today",
  YESTERDAY: "yesterday",
  THIS_WEEK: "this_week",
  LAST_WEEK: "last_week",
  THIS_MONTH: "this_month",
  LAST_MONTH: "last_month"
};

const INVOICE_FORM_FIELD = {
  SUBMISSION_STATUS: "submission_status"
};

const INVOICE_STATUS = {
  POSTED: "POSTED"
};

const PDF_FILE_NAME_FILED = {
  [STATIC_FORM_TEMPLATE_ID.INVOICE_FORMS]:
    "15376b7e-542c-4485-9bda-00887d732123"
};

const TRIGGER_EXECUTION_TIMING = {
  IMMEDIATELY: "IMMEDIATELY",
  CLICK_PREVIEW: "CLICK_PREVIEW",
  CLICK_BUTTON: "CLICK_BUTTON"
};

const TRIGGER_FIELD = {
  EXECUTION_TIMING: "execution_timing"
};

const FIXED_FETCH_OPTIONS_KEYS = {
  USER_ID: "USER_ID",
  USER_NAME: "USER_NAME",
  USER_EMAIL: "USER_EMAIL",
  LATLONG: "LATLONG",
  USER_ROLE_CHECK: "USER_ROLE_CHECK"
};

const DEFECT_TYPE_IDS = {
  POTHOL: "0b839588-96bd-4392-acfb-4ef12abd1a74",
  HIGHWAY_SIGNS_AND_DELINEATION: "a1b2c3d4-e5f6-4a5b-8c7d-9e8f7a6b5c4d",
  PAVED_SURFACES: "b2c3d4e5-f6a7-5b6c-9d8e-0f1a2b3c4d5e",
  GUARDRAIL_AND_BARRIERS: "c3d4e5f6-a7b8-6c7d-0e1f-2a3b4c5d6e7f",
  LINES_AND_MARKINGS: "eaaeb2b8-74be-42d7-b2dc-72e04780fbe9",
  GRAVEL_SURFACE_HIGHWAY: "8c4b1d92-050c-4306-8b3b-4d7ed8e4c241",
  RIGHT_OF_WAY: "8a7f0e67-bc03-4b5e-9740-43fef0f17618",
  THIRD_PARTY_SIGNS: "fdf75d2b-0df4-4961-b360-422ec45aa74a",
  CULVERT_INSPECTION: "5e048626-01a6-441c-a264-dbd4611c84f0"
};

const INSPECTION_TYPE_IDS = {
  ANIMAL_CARCASS: "ca9a56fb-94da-41d0-b415-f69d9e7b27e8",
  DEBRIS_REMOVAL: "d9d82ff3-c299-40f5-ac12-27db6174d0a2",
  LITTER_CONTROL: "74872f46-fde3-41d9-b5f2-995729112c0e",
  NIGHTTIME_LIGHTING: "f14f931c-60bf-4de8-b65b-123a20bf12f9",
  TRAFFIC_SIGNAL_CABINET: "3047098b-02de-462f-a915-285b6519a37b",
  NIGHTTIME_SIGN_REFLECTIVITY: "ef63bb72-a059-4188-a470-377bb5c0ba9d",
  SPRING_THAW_DRAINAGE: "d2480f68-f2d5-4898-9542-ae076b1d5d9b",
  CULVERT_INSPECTION: "5e048626-01a6-441c-a264-dbd4611c84f0",
  WASHROOM_CLEANING: "a14a5b07-b3ca-4ee1-b26d-6bdb916793e5",
  GRAFFITI_REMOVAL: "69cee3c4-0c29-4536-9a44-7772ffdc4e77"
};

const FIXED_LAT_LONG = {
  HANNA: {
    LAT: 51.3352,
    LNG: -111.9044
  }
};

const DEVICE_MAPPING = {
  IOS_DEVICE_MAPPING: new Map([
    ["320x480", "IPhone 4S, 4, 3GS, 3G, 1st gen"],
    ["320x568", "IPhone 5, SE 1st Gen,5C, 5S"],
    ["375x667", "IPhone SE 2nd Gen, 6, 6S, 7, 8"],
    ["375x812", "IPhone X, XS, 11 Pro, 12 Mini, 13 Mini"],
    ["390x844", "IPhone 13, 13 Pro, 12, 12 Pro"],
    ["414x736", "IPhone 8+"],
    ["414x896", "IPhone 11, XR, XS Max, 11 Pro Max"],
    ["428x926", "IPhone 13 Pro Max, 12 Pro Max"],
    ["476x847", "IPhone 7+, 6+, 6S+"],
    ["744x1133", "IPad Mini 6th Gen"],
    [
      "768x1024",
      "IPad Mini (5th Gen), IPad (1-6th Gen), iPad Pro (1st Gen 9.7), Ipad Mini (1-4), IPad Air(1-2)  "
    ],
    ["810x1080", "IPad 7-9th Gen"],
    ["820x1180", "iPad Air (4th gen)"],
    ["834x1194", "iPad Pro (3-5th Gen 11)"],
    ["834x1112", "iPad Air (3rd gen), iPad Pro (2nd gen 10.5)"],
    ["1024x1366", "iPad Pro (1-5th Gen 12.9)"]
  ]),

  DESKTOP_DEVICE_MAPPING: new Map([
    ["Win32", "Windows"],
    ["Linux", "Linux"],
    ["MacIntel", "Mac OS"]
  ])
};

const FORMAT_FIELD_TYPES = {
  CURRENCY: "currency",
  DATE: "date",
  TAG: "tag",
  ICON: "icon",
  MATH: "math"
};

const USE_MODE = {
  WIFI_ONLY: "WIFI_ONLY",
  CELLULAR_ONLY: "CELLULAR_ONLY",
  WIFI_AND_CELLULAR: "WIFI_AND_CELLULAR"
};

const BLADE_INVENTORY = {
  SHOP_TYPES: {
    HUB: "hub",
    ORPHAN: "orphan",
    CHILD: "child"
  },

  SHOP_TYPE_LABELS: {
    HUB: "Hub",
    SHOP: "Shop"
  },

  INVENTORY_FIELDS: {
    ON_HAND: "ON HAND",
    MIN: "MIN",
    MAX: "MAX",
    LAST_INVENTORY_COUNT: "LAST INVENTORY COUNT"
  },

  FIELD_IDS: {
    BLADE_ORDERS: "81551f01-802a-41d5-9a27-1ccee8d9f7a2",
    SHOP: "c7043e95-659e-4be7-a6cc-0ba43f86d8c5",
    BLADE_TYPE: "ef1e81f9-fd27-4508-b909-ae8e09d5852e",
    QUANTITY: "c0d11815-38d2-4b27-a868-38ae29e8b99d",
    SUBMISSION_STATUS: "submission_status",
    USER_NAME: "submiited_by_name",
    USER_EMAIL: "submitted_by_email"
  },

  STATUS: {
    NEW: "NEW",
    INACTIVE: "INACTIVE"
  },

  TYPE: {
    SHOP: "shop",
    BLADE_TYPE: "blade_type"
  }
};

const PERMISSION_LEVELS = {
  NONE: { key: "none", label: "None" },
  ADMIN: { key: "admin", label: "Admin" },
  READER: { key: "reader", label: "Reader" },
  WRITER: { key: "writer", label: "Writer" },
  APPROVER: { key: "approver", label: "Approver" }
};

const PERMISSION_CATEGORIES = {
  FORM: { key: "form", label: "Form" },
  SHOP: { key: "shop", label: "Shop" },
  REGION: { key: "region", label: "Region" },
  COMPANY: { key: "company", label: "Company" },
  DASHBOARD: { key: "dashboard", label: "Dashboard" }
};

const BASIC_INFO_FIELDS = [
  { key: "emp_id", label: "Employee ID" },
  { key: "full_name", label: "Full Name" },
  { key: "email", label: "Email" },
  { key: "selected_company", label: "Company" }
];

const MASTER_COMPANY_CODE = "ALL";

const BUTTON_LAYOUT = {
  INLINE: "inline",
  STACKED: "stacked"
};

const FLHA_STATUS = {
  NEW: "NEW",
  OPEN: "OPEN",
  SUBMITTED: "SUBMITTED",
  REVIEWED: "REVIEWED"
};

const TOGGLE_SWITCHES = {
  SHOW_MIN_MAX: "SHOW_MIN_MAX",
  SHOW_LAST_INVENTORY_COUNTS: "SHOW_LAST_INVENTORY_COUNTS"
};

const SCREEN_SIZE = {
  XS: "xs",         // <640px
  SM: "sm",         // 640px - 768px
  MD: "md",         // 768px - 1024px
  LG: "lg",         // 1024px - 1280px
  XL: "xl",         // 1280px - 1536px
  XXL: "2xl"        // >1536px
};

const NIGHTTIME_LIGHTING_DEFECT_TYPE = {
  DAMAGE: "Damage",
  OUTTAGE: "Outtage",
  OTHER: "Other"
};

const NIGHTTIME_LIGHTING_DEFECT_PRIORITY = {
  HIGH: "High",
  MEDIUM: "Medium",
  LOW: "Low"
};

const YES_NO_NA = {
  YES: "Yes",
  NO: "No",
  NA: "N/A"
};

export default {
  ROUTE_ENUM,
  TABLES_NAME_ENUM,
  DATABASE_FUNCTION_ENUM,
  RXDB_COLLECTIONS_ENUM,
  API_RESPONSE_STATUS_ENUM,
  DATASTORE_BUCKET_ENUM,
  DEVICE_TYPE,
  COMPANY_OPTIONS,
  FLRA_STATUS,
  FLRA_STATUS_IDS,
  HSE_EMAILS,
  FLRA_COMPANIES,
  NO_REPLY_EMAILS_ID,
  PRE_DEFINED_LIST_IDS,
  WORKHUB_FORM_NAMES,
  PROJECT_ENVIRONMENT,
  NAVIGATION_BTN_ACTIONS,
  FORM_TEMPLATE_IDS,
  FIELD_TYPES,
  FIELD_TYPES_DONT_VALIDATE,
  PAGE_TEMPLATE_TYPE,
  PROGRESS_STATUS,
  IMAGE_PREVIEW_TYPE,
  FLRA_USER_ROLES,
  FLRA_FORMS_CATEGORY,
  DEBOUNCE_TIME,
  FORM_TYPE,
  COMPARISON_TYPE,
  FLRA_COMPANIES_OPTIONS,
  FLRA_FORM_FIELD,
  STATIC_FORM_TEMPLATE_ID,
  FILE_EXTENSION_TYPE,
  IMAGE_EXTENSION_TYPE,
  EMAIL_ACTION_TYPES,
  EMAIL_RECIPIENT_TYPES,
  FORM_TYPES,
  APP_SETTINGS,
  ERROR_TYPE,
  BEFORE_AFTER_ACTION_TYPES,
  ERROR_TYPE,
  DATE_FILED,
  INVOICE_FORM_FIELD,
  INVOICE_STATUS,
  PDF_FILE_NAME_FILED,
  INVOICE_STATUS,
  TRIGGER_EXECUTION_TIMING,
  TRIGGER_FIELD,
  FIXED_FETCH_OPTIONS_KEYS,
  DEFECT_TYPE_IDS,
  INSPECTION_TYPE_IDS,
  DEFECTS_STATUS,
  DEFECT_STATUS_GROUPS,
  FIXED_LAT_LONG,
  DEVICE_MAPPING,
  FORMAT_FIELD_TYPES,
  USE_MODE,
  BLADE_INVENTORY,
  SUPER_ADMIN_ID,
  PERMISSION_LEVELS,
  PERMISSION_CATEGORIES,
  BASIC_INFO_FIELDS,
  MASTER_COMPANY_CODE,
  BUTTON_LAYOUT,
  FLHA_STATUS,
  QC_STATUS_OPTIONS,
  PATROL_REPORT_STATUS_CLASSES,
  TOGGLE_SWITCHES,
  SCREEN_SIZE,
  NIGHTTIME_LIGHTING_DEFECT_TYPE,
  NIGHTTIME_LIGHTING_DEFECT_PRIORITY,
  YES_NO_NA
};